import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cdcaaa9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "root-layout" };
import HeaderBar from './components/HeaderBar.vue';
import Footer from './components/Footer.vue';
import { provide, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'layout',
    setup(__props) {
        const isMobile = ref(window.innerWidth < 768);
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth < 768;
        });
        provide('isMobile', isMobile);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            const _component_a_layout_content = _resolveComponent("a-layout-content");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(HeaderBar),
                _createVNode(_component_a_layout_content, { class: "root-content" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_router_view)
                    ]),
                    _: 1
                }),
                _createVNode(Footer)
            ]));
        };
    }
});
